






























































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue"
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BaseSheet, Daimon } from "../../modules/teacher/DaimonUpload"


export interface Data {
  tabNo: number
  base_sheet_id: string
  baseSheet: BaseSheet
  daimons: Daimon[]
  currentDaimon: Daimon | null
  currentDaimonIdx: number
  errors: string[]
  scale: number
  rotates: number[]
  file: any
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      tabNo: 7,
      base_sheet_id: "",
      baseSheet: new BaseSheet({}),
      daimons: [],
      currentDaimon: null,
      currentDaimonIdx: 0,
      errors: [],
      scale: 0.5,
      rotates: [0, 90, 180, 270],
      file: null,
    });

    /******************************
     * computed
     ******************************/

    // 画像プレビューエリアの表示制御
    const isShowDaimonImage = computed((): boolean => {
      return state.daimons.filter(x => x.registed).length > 0;
    });

    // imgタグのスタイル
    const imageStyle = computed((): object => {
      let style: any = {};
      const daimon: Daimon | null = state.currentDaimon;
      if(daimon != null){
        style["width"] = `${daimon.baseWidth * state.scale}px`;
        style["height"] = `${daimon.baseHeight * state.scale}px`;
        style["transform"] = `rotate(${daimon.angle}deg)`;
        
        // 回転の中心軸設定
        let translateX: string = "";
        let translateY: string = "";
        if(daimon.angle == 90){
          translateX = `${daimon.baseHeight * state.scale / 2}px`;
          translateY = `${daimon.baseHeight * state.scale / 2}px`;
        }else if(daimon.angle == 180){
          translateX = `${daimon.baseWidth * state.scale / 2}px`;
          translateY = `${daimon.baseHeight * state.scale / 2}px`;
        }else if(daimon.angle == 270){
          translateX = `${daimon.baseWidth * state.scale / 2}px`;
          translateY = `${daimon.baseWidth * state.scale / 2}px`;
        }
        style["transform-origin"]  = `${translateX} ${translateY}`;
      }
      return style;
    });

    // imgの親divのスタイル
    const imageWrapStyle = computed((): object => {
      let style: any = {};
      const daimon: Daimon | null = state.currentDaimon;
      if(daimon != null){
        if(daimon.angle == 0 || daimon.angle == 180){
          style["height"] = `${(daimon.baseHeight * state.scale) + 30}px`;
        }else{
          style["height"] = `${(daimon.baseWidth * state.scale) + 30}px`;
        }
      }
      return style;
    });

    /******************************
     * methods
     ******************************/

    // アップロード
    const upload = async (file: any) => {

      let fd = new FormData();
      fd.append('upload[file]', file[0]);

      if(!window.confirm("ファイルをアップロードします。登録済み大問の画像は上書きされます。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/daimon_upload/upload/${state.base_sheet_id}`, fd).then(response => {
        state.baseSheet = response.data.base_sheet_hash;
        state.daimons = response.data.daimon_hashes.map((x: any) => new Daimon(x));
        for (var i = 0; i < state.daimons.length; i++) {
          if (state.daimons[i].registed) {
            changeCurrent(i);
            break;
          }
        }
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // 選択情報切り替え
    const changeCurrent = async (daimonIdx: number) => {
      const changeDaimon = state.daimons[daimonIdx];
      if (changeDaimon.registed) {
        state.currentDaimon = changeDaimon;
        state.currentDaimonIdx = daimonIdx;
      }
    };

    // 拡大ボタン押下
    const scaleUp = () => {
      state.scale += 0.05;
    };

    // 縮小ボタン押下
    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    };

    // 画像を表示エリアの横幅に合わせる
    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth;
        state.scale = imageAreaW / state.currentDaimon.baseWidth;
      }
    };

    // 画面サイズに合わせてレイアウト整形
    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");

      if(tableArea != null && imageArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop) + "px";
        imageArea.style.height = (winH - imageArea.offsetTop) + "px";
      }
    };

    // 前へボタン押下
    const prevCurrent = () => {
      if (state.currentDaimonIdx > 0) {
        for (var i = state.currentDaimonIdx - 1; i >= 0; i--) {
          if (state.daimons[i].registed) {
            changeCurrent(i);
            break;
          }
        }
      }
    };

    // 次へボタン押下
    const nextCurrent = () => {
      if (state.daimons.length - 1 > state.currentDaimonIdx) {
        for (var i = state.currentDaimonIdx + 1; i < state.daimons.length; i++) {
          if (state.daimons[i].registed) {
            changeCurrent(i);
            break;
          }
        }
      }
    };

    // 左回転ボタン押下
    const rotateLeft = async() => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentDaimon.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = state.currentDaimon.angle - 90;
      }
      state.currentDaimon.angle = angle;

      await rotateSave(false, false);
    };

    // 右回転ボタン押下
    const rotateRight = async () => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentDaimon.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = state.currentDaimon.angle + 90;
      }
      state.currentDaimon.angle = angle;

      await rotateSave(false, false);
    };

    // 回転保存ボタン押下
    const rotateSave = async (isConfirmMsg: boolean = true, isResutMsg: boolean = true) => {
      
      if(state.currentDaimon.angle == 0){
        alert("回転情報は変更されていません。");
        return;
      }
      
      if(isConfirmMsg && !window.confirm(`回転状態を保存します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        angle: state.currentDaimon.angle,
        daimon_no: state.currentDaimon.daimon_no
      };

      await http.post(`/api/daimon_upload/rotate/${state.base_sheet_id}`, param).then(response => {
        if (isResutMsg) {
          alert("処理が完了しました。");
        }
        state.currentDaimon.base64Image = response.data.base64_image;
        state.currentDaimon.baseWidth = response.data.image_size_hash.width;
        state.currentDaimon.baseHeight = response.data.image_size_hash.height;
        state.currentDaimon.angle = 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // 一括回転
    const rotateAll = async (angle: number) => {

      if(!window.confirm(`一括回転を実行します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        angle: angle
      };

      await http.post(`/api/daimon_upload/rotate_all/${state.base_sheet_id}`, param).then(response => {
        state.daimons = response.data.daimon_hashes.map((x: any) => new Daimon(x));
        state.currentDaimon = state.daimons.filter(x => x.daimon_no == state.currentDaimon.daimon_no)[0];
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // 削除ボタン押下
    const destroy = async (daimon: Daimon) => {
      if(!window.confirm(`大問${daimon.daimon_no}のpng画像を削除します。よろしいですか？`)){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/daimon_upload/destroy/${state.base_sheet_id}/${daimon.daimon_no}`).then(response => {
        state.baseSheet = response.data.base_sheet_hash;
        state.daimons = response.data.daimon_hashes.map((x: any) => new Daimon(x));
        for (var i = 0; i < state.daimons.length; i++) {
          if (state.daimons[i].registed) {
            changeCurrent(i);
            break;
          }
        }
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // 一括削除ボタン押下
    const destroyAll = async () => {

      if(state.daimons.length == 0){
        alert("削除対象が存在しません。");
        return;
      }

      if(!window.confirm("大問画像を一括削除します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/daimon_upload/destroy_all/${state.base_sheet_id}`).then(response => {
        state.baseSheet = response.data.base_sheet_hash;
        state.daimons = response.data.daimon_hashes.map((x: any) => new Daimon(x));
        for (var i = 0; i < state.daimons.length; i++) {
          if (state.daimons[i].registed) {
            changeCurrent(i);
            break;
          }
        }
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // keyUpイベント
    const keyUp = (e: KeyboardEvent): void => {

      if (e.key == "ArrowDown") {
        e.preventDefault();

        nextCurrent();
        return;
      }

      if (e.key == "ArrowUp") {
        e.preventDefault();

        prevCurrent();
        return;
      }
    }

    /******************************
     * created
     ******************************/

    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;

      await http.get(`/api/daimon_upload?base_sheet_id=${state.base_sheet_id}`).then(response => {
        state.baseSheet = response.data.base_sheet_hash;
        state.daimons = response.data.daimon_hashes.map((x: any) => new Daimon(x));
        for (var i = 0; i < state.daimons.length; i++) {
          if (state.daimons[i].registed) {
            changeCurrent(i);
            break;
          }
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goBaseSheetList");
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("keyup", keyUp);
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      isShowDaimonImage,
      imageStyle,
      imageWrapStyle,
      upload,
      changeCurrent,
      scaleUp,
      scaleDown,
      adjustWidth,
      adjustHeight,
      prevCurrent,
      nextCurrent,
      rotateLeft,
      rotateRight,
      rotateSave,
      rotateAll,
      destroy,
      destroyAll,
    };
  }
})
